import { render, staticRenderFns } from "./reportChannel.vue?vue&type=template&id=66400b64&scoped=true"
import script from "./reportChannel.vue?vue&type=script&lang=js"
export * from "./reportChannel.vue?vue&type=script&lang=js"
import style0 from "./reportChannel.vue?vue&type=style&index=0&id=66400b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66400b64",
  null
  
)

export default component.exports